export default {"src":"/_next/static/media/arrow-left-new.f576b706.svg","height":12,"width":8};